<template>
  <div>
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <span class="pl-2" v-show="currentMonth.length > 0">
            {{ $t("affiliatesPayments.paymentReferringMonth") }}
            <strong class="primary--text">
              {{ currentMonth }}
            </strong>
          </span>
          <v-spacer />
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <v-data-table
        :headers="headers"
        :items="items"
        item-key="name"
        class="historic-bet"
        :search="search"
        :dense="$vuetify.breakpoint.smAndDown"
        :no-data-text="$t('nullData')"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.invoice_id="{ item }">
          <v-btn @click="$copy(item.invoice_id)" x-small>
            {{ item.invoice_id }}
          </v-btn>
        </template>

        <template v-slot:item.register_date="{ item }">
          {{
            item.register_date
              ? new Date(item.register_date.replace(" ", "T")).toLocaleString()
              : ""
          }}
        </template>

        <template v-slot:item.player_login="{ item }">
          {{ item.player_login }} <small>({{ item.bound_player }})</small>
        </template>

        <template v-slot:item.value="{ item }">
          <span class="green--text">
            {{ item.value }}
          </span>
        </template>
      </v-data-table>
    </v-card>
    <!-- <div class="mt-4">
      <Resume
        :data_resume="{
          data: items,
          keys: ['value'],
          showSum: true,
          hideAlert: true,
        }"
        :month="currentMonth"
      />
    </div> -->
  </div>
</template>

<script>
// import Resume from "@/components/backoffice/resume_global/resume";

export default {
  data: () => ({
    items: [],
    search: "",
    currentMonth: "",
  }),

  // components: { Resume },

  watch: {
    saveFilters(val) {
      val && this.fetchAffiliateTransfers();
    },
  },

  computed: {
    month() {
      const { year, month } = this.$store.getters.getMonthAndYearOfPayment;

      const date = new Date(year, month - 1, 1).toLocaleDateString("default", {
        year: "numeric",
        month: "long",
      });

      return date.charAt(0).toUpperCase() + date.slice(1);
    },
    headers() {
      return [
        { text: "Id", value: "invoice_id" },
        { text: this.$t("affiliatesPayments.invoiceEmission"), value: "register_date" },
        {
          text: this.$t("affiliatesPayments.linkedPlayer"),
          value: "player_login",
        },
        {
          text: this.$t("value"),
          value: "value",
        },
      ];
    },
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },
    namePlayer() {
      return this.$store.state.filters.autocompleteNamePlayers.player_name;
    },
    resultBet() {
      return this.$store.state.filters.selectResultBet.result;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    retail() {
      return this.$store.state.operators.retail;
    },
  },

  methods: {
    fetchAffiliateTransfers() {
      const { year, month } = this.$store.getters.getMonthAndYearOfPayment;

      const body = { year, month };

      this.items = [];
      this.currentMonth = "";

      this.$request
        .post("agent/financial/affiliatesPaidCommissionHistory", body)
        .then((res) => {
          this.items = res.data.dados;
          this.currentMonth = this.month;
        });
    },
  },
};
</script>
